// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AnimatedBackgroundPanel__member-list-exit-e5e5c1 {
  width: 360px;
}

.AnimatedBackgroundPanel__member-list-exit-active-e0cb90 {
  width: 0;
  transition: width 100ms ease-out;
  background-color: var(--addition-80);
}

.AnimatedBackgroundPanel__member-list-enter-eda0dc {
  width: 0;
}

.AnimatedBackgroundPanel__member-list-enter-active-d29a9e {
  width: 360px;
  transition: width 100ms ease-out;
  background-color: var(--addition-80);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/AnimatedBackgroundPanel/AnimatedBackgroundPanel.transitions.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,QAAA;EACA,gCAAA;EACA,oCAAA;AACF;;AAEA;EACE,QAAA;AACF;;AAEA;EACE,YAAA;EACA,gCAAA;EACA,oCAAA;AACF","sourcesContent":[".member-list-exit {\n  width: 360px;\n}\n\n.member-list-exit-active {\n  width: 0;\n  transition: width 100ms ease-out;\n  background-color: var(--addition-80);\n}\n\n.member-list-enter {\n  width: 0;\n}\n\n.member-list-enter-active {\n  width: 360px;\n  transition: width 100ms ease-out;\n  background-color: var(--addition-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"member-list-exit": `AnimatedBackgroundPanel__member-list-exit-e5e5c1`,
	"memberListExit": `AnimatedBackgroundPanel__member-list-exit-e5e5c1`,
	"member-list-exit-active": `AnimatedBackgroundPanel__member-list-exit-active-e0cb90`,
	"memberListExitActive": `AnimatedBackgroundPanel__member-list-exit-active-e0cb90`,
	"member-list-enter": `AnimatedBackgroundPanel__member-list-enter-eda0dc`,
	"memberListEnter": `AnimatedBackgroundPanel__member-list-enter-eda0dc`,
	"member-list-enter-active": `AnimatedBackgroundPanel__member-list-enter-active-d29a9e`,
	"memberListEnterActive": `AnimatedBackgroundPanel__member-list-enter-active-d29a9e`
};
module.exports = ___CSS_LOADER_EXPORT___;
